var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLightning = function SvgIconLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.315,
    height: 48.997
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#28aae1",
    "data-name": "ICON - Lightning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.274.158 35.59 0l-7.065 22.258 9.023.1L12.538 49l6.567-22.151-8.467.116Z",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.611 11.641a.814.814 0 0 1-.578-1.391l5.889-5.892a.817.817 0 0 1 1.156 1.153l-5.889 5.892a.83.83 0 0 1-.578.238",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.816 42.349a.83.83 0 0 1-.578-.237.82.82 0 0 1 0-1.153l5.893-5.893a.816.816 0 1 1 1.156 1.153l-5.892 5.893a.82.82 0 0 1-.579.237",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.708 11.641a.82.82 0 0 1-.578-.237L.237 5.512a.817.817 0 1 1 1.156-1.153l5.892 5.892a.814.814 0 0 1-.578 1.391Z",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.493 42.349a.83.83 0 0 1-.578-.237l-5.889-5.893a.817.817 0 0 1 1.156-1.153l5.889 5.893a.814.814 0 0 1-.578 1.39",
    "data-name": "Path 16"
  })))));
};
export default SvgIconLightning;